import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaTicketSocialPage } from './plaza-ticket-social';

@NgModule({
  declarations: [
    PlazaTicketSocialPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaTicketSocialPage),
    TranslateModule.forChild()
  ],
})
export class PlazaTicketSocialPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-ticket-social/plaza-ticket-social.module.ts